// İSG uzmanı portalı — Kapı kodu sahnesi: `Giriş` panelinin `QR` alt-sekmesinin gövdesi.
// Yoklama/dönme hook'u (`useGateCode`) `SecuritySiteSession`'da YAŞAR (S32 tasarım spec'i §8.9 —
// sekme değişse bile durmaz); bu bileşen o hook'un SONUCUNU SUNAR, kendi yoklama YAŞAM DÖNGÜSÜ
// TAŞIMAZ.
//
// **S32b'de DEĞİŞEN.** Karar artık burada DEĞİL — `VerdictPanel.tsx` sayfanın TEK verdict
// yüzeyidir (Option A). Bu yüzden bu bileşen KÜÇÜLDÜ: eski 58/40 "sahne var/yok" iki-bölgeli
// düzeni ve `VerdictStage`/`AutoClearIndicator` alt bileşenleri KALKTI — QR HER ZAMAN aynı
// boyutta, aynı yerde durur (`idle` TEK görsel durumdur; `issuing`/`error`/`forbidden`/
// `tokenExpired` birer bildirim panelidir). Kendi `rounded-lg border` kabuğunu da TAŞIMAZ —
// `EntryPanel.tsx`'in panel gövdesine oturur.
//
// **İkinci tur, owner canlı-kullanım bulgusu — bağlantı göstergesi (`SecurityDeskPage.tsx`'in
// bağlam çubuğuyla AYNI karar, dosya başı notu).** Sabit yeşil "Bağlı" rozeti KALKTI — QR'ın TAM
// YANINDA duran bu ikinci nüsha, riskin GERÇEK yeri: yoklama dururken kod SESSİZCE dönmeyi
// bırakır. `!gate.connectionOk` iken güçlendirilmiş bir `Alert tone="danger"` çıkar, AKSİ HÂLDE
// hiçbir şey render edilmez.
//
// **S32d — okutma SAHNEYE çıkınca QR ekrandan kalkar (owner talebi, `docs/reviews/
// S32d-verdict-and-detail.md` §3).** `verdictPending` (`SecuritySiteSession.tsx`'ten
// `verdictStage.stage != null`) doğruyken ve panel aksi hâlde kodu gösterecekken (`idle`)
// `QrCodeCanvas` render EDİLMEZ — bir `EyeOff` bildirimi onun yerini alır. Guard `Kapat`'a
// basıp sahneyi TEMİZLEDİĞİNDE (`verdictStage.acknowledge`) kod GERİ döner. **Yoklama/dönme
// (`useGateCode.ts`) DURMAZ** — bu yalnız GÖRÜNÜRLÜK, oturumun kendisi değil; kod arka planda
// dönmeye/yoklanmaya devam eder, guard `Kapat`'a basmadan da oturumu `onStop` ile kapatabilir.
//
// **G7 fix (`docs/reviews/S32e-evidence-and-layout.md` §4.3 madde 1) — gövde tabanı `min-h-[16rem]`
// → `min-h-[28rem]`.** S32e Part Two `Giriş`i `[Karar | Giriş]` ızgarasının BİRİNCİ satırına
// taşıdı (`SecuritySiteSession.tsx`); eskiden QR↔bildirim geçişi yalnız BİR sütunun yüksekliğini
// değiştirirdi (tam-genişlik `Bugün` tablosunun ALTINDA), artık SATIRIN kendisini değiştirir —
// yani tam-genişlik `Bugün` her okutmada/`Kapat`ta ~184px zıplardı. Taban artık QR bloğunun
// (`QR_SIZE` 268 + plaka/halka dolgusu + talimat satırı + "yenilenir" satırı, ölçülen gövde
// ~424px) ölçüsünü KAPSAYACAK şekilde SABİTLENDİ — `28rem` (448px) aritmetik BAŞLANGIÇ noktası,
// `web-qa-engineer` gerçek pikseli DOĞRULAMALI (VerdictPanel'in AYNI disiplini, S32c E5/S32d
// F3). Bildirim panelleri (`forbidden`/`error`/`tokenExpired`/`hideCode`) DAHA KISA olduğundan
// bu taban onları da KAPSAR — hiçbiri kendi min-h'ini AŞMAZ. **Bu taban BU GÖREVDE DEĞİŞMEDİ**
// (aşağıdaki S32f notu) — tek-izinli bir kartta kalan ~300px havanın gerçek sebebi budur.
//
// **S32f (`docs/reviews/S32e-evidence-and-layout.md` §4.3 madde 3/§18.1) — site adının ÜÇÜNCÜ
// kopyası SİLİNDİ.** QR'ın altındaki `text-xl` site adı satırı sayfa `h1`'i VE bağlam çubuğu
// `Select`'i ile AYNI sözcüğü ÜÇÜNCÜ kez basıyordu — S32e §4.3 madde 3'te specify EDİLMİŞ ama HİÇ
// GÖNDERİLMEMİŞTİ. Silinmesiyle `siteName` prop'u bu bileşenden (ve `GateCodeTab`/`EntryPanel`
// zincirinden) TAMAMEN KALKTI — kalan tek tüketicisi buydu. **Bu, evidence şeridini dolduran
// S32f değişikliğiyle birlikte gelen ~32px'lik ayrı bir kesinti** — kalan büyük boşluğu (tek
// izinli bir kartta ~300px) KAPATMAZ, o `min-h-[28rem]` tabanının kendisidir (yukarıdaki not).
//
// **Sahibe bayraklanmış gerilim, ÇÖZÜLMEDEN bırakıldı (bu satırı "düzeltmeyin"):** kodun
// 120 sn'lik penceresi İÇİNDE ÇOK-KULLANIMLI olması BİLİNÇLİ bir tasarımdı (aynı kapıdan art
// arda giren birden çok işçinin AYNI dönmeyen kodu okutabilmesi için, §29.2). Bir okutma
// sahneye çıkar çıkmaz kodu gizlemek, guard `Kapat`'a basana kadar gişeyi FİİLEN TEK KİŞİLİK
// yapar — bu tam olarak çok-kullanımlılığın var olma SEBEBİNİ iptal eder. Owner talebi AÇIK ve
// burada olduğu gibi UYGULANDI; gerilim kendisine AYRICA raporlandı, bu görevde ÇÖZÜLMEDİ.

import { Alert, Button, Spinner } from '@isgportal/shared';
import { AlertTriangle, EyeOff, ShieldAlert, WifiOff, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { UseGateCodeResult } from '../../lib/useGateCode';
import { QrCodeCanvas } from './QrCodeCanvas';

// 268 (240 DEĞİL) — marka rozeti overlay'i ECC'yi `'M'`→`'H'`'ye zorlar (S32c §6.1/§6.4);
// `'H'` 43 baytlık jetonu bir versiyon YUKARI iter (v4→v5, 33→37 modül). Boyut sabit kalsaydı
// modül aralığı ~%10 DÜŞERDİ (6.86 → 6.15 px/modül) — 268 bu düşüşü TELAFİ eder, bugünkü
// tarama marjı KORUNUR (tam sayılar `QrCodeCanvas.tsx`'in dosya başı notunda).
const QR_SIZE = 268;

export interface GateStageProps {
  gate: UseGateCodeResult;
  onStop: () => void;
  /** S32d — sahnede bir karar varken kod gizlenir (dosya başı notu, TAM gerekçe orada). */
  verdictPending: boolean;
}

export function GateStage({ gate, onStop, verdictPending }: GateStageProps) {
  const { t } = useTranslation();
  const ringPercent = gate.ringProgress != null ? Math.round(gate.ringProgress * 100) : null;
  const hideCode = verdictPending && gate.panel.kind === 'idle';

  return (
    <div className="flex flex-col gap-4 p-5">
      <div className="flex items-center justify-between gap-3">
        {!gate.connectionOk ? (
          <Alert tone="danger" className="flex items-center gap-1.5 px-2.5 py-1 text-xs">
            <WifiOff className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            {t('security.context.offlineGateStale')}
          </Alert>
        ) : (
          // Boş yer tutucu — `justify-between` İKİ çocuk BEKLER; bağlıyken sol slot boşalır ama
          // sağdaki "Kodu kapat" düğmesi yine de SAĞDA kalmalı (tek çocuk olsaydı sola kayardı).
          <span aria-hidden="true" />
        )}
        <button
          type="button"
          onClick={onStop}
          className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs text-muted hover:bg-surface-muted hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <X className="h-3.5 w-3.5" aria-hidden="true" />
          {t('security.gate.stop')}
        </button>
      </div>

      <div className="flex min-h-[28rem] flex-1 items-center justify-center">
        {gate.panel.kind === 'forbidden' ? (
          <NoticePanel
            icon={ShieldAlert}
            title={t('security.gate.forbidden.title')}
            body={t('security.gate.forbidden.body')}
          />
        ) : gate.panel.kind === 'error' ? (
          <NoticePanel
            icon={WifiOff}
            title={t('security.verdict.networkError.title')}
            body={t('security.gate.issueError.body')}
            actionLabel={t('security.gate.retry')}
            onAction={gate.reissue}
          />
        ) : gate.panel.kind === 'tokenExpired' ? (
          <NoticePanel
            icon={AlertTriangle}
            title={t('security.gate.expired.title')}
            body={t('security.gate.expired.body')}
            actionLabel={t('security.gate.newCode')}
            onAction={gate.reissue}
          />
        ) : gate.panel.kind === 'issuing' ? (
          <Spinner label={t('security.gate.issuing')} />
        ) : hideCode ? (
          <NoticePanel
            icon={EyeOff}
            title={t('security.gate.hidden.title')}
            body={t('security.gate.hidden.body')}
          />
        ) : (
          <div className="flex flex-col items-center gap-4 text-center">
            {gate.qrToken ? (
              <div
                className="flex items-center justify-center rounded-full p-3"
                style={
                  ringPercent != null
                    ? {
                        background: `conic-gradient(var(--color-primary) ${ringPercent}%, var(--color-border) ${ringPercent}%)`,
                      }
                    : undefined
                }
              >
                <div className="rounded-lg bg-bg p-2">
                  {/* `QrCodeCanvas` kendi tema-bağımsız sessiz-bölge plakasını (S32c §6.2) VE
                      marka rozetini (§6.4) taşır — bu `bg-bg` sarmalı yalnız DIŞ bir çerçeve,
                      artık sembolün sessiz bölgesine BİTİŞİK DEĞİL (koyu temada zararsız). */}
                  <QrCodeCanvas value={gate.qrToken} size={QR_SIZE} withMark />
                </div>
              </div>
            ) : null}
            <p className="text-sm text-muted">{t('security.gate.workerInstruction')}</p>
            {gate.secondsRemaining != null ? (
              <p aria-live="polite" className="text-xs font-medium text-muted">
                {t('security.gate.rotatesIn', { seconds: gate.secondsRemaining })}
              </p>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}

function NoticePanel({
  icon: Icon,
  title,
  body,
  actionLabel,
  onAction,
}: {
  icon: typeof ShieldAlert;
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex max-w-md flex-col items-center gap-4 text-center">
      <Icon className="h-10 w-10 text-muted" aria-hidden="true" />
      <div className="flex flex-col gap-1.5">
        <h3 className="text-lg font-semibold text-fg">{title}</h3>
        <p className="text-sm text-muted">{body}</p>
      </div>
      {actionLabel && onAction ? (
        <Button size="lg" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}
